import { AfterViewInit, Component, ElementRef, Input, ViewChild } from '@angular/core';

import { ModalService } from '../../../services/modal.service';

@Component({
  selector: 'app-yes-no-modal',
  templateUrl: './yes-no-modal.component.html',
  styleUrl: './yes-no-modal.component.scss',
})
export class YesNoModalComponent implements AfterViewInit {
  @ViewChild('focus') focus: ElementRef<HTMLButtonElement>;

  @Input() header: string;
  @Input() message: string;

  constructor(private modalService: ModalService) {}

  ngAfterViewInit(): void {
    this.focus.nativeElement.focus();
  }

  onYes() {
    this.modalService.close(true);
  }

  onNo() {
    this.modalService.close(false);
  }
}
